import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AccountOpportunityService {
  appUrl:string = environment.opportunityUrl + "Opportunity/";
  appOrgUrl: string;
  constructor(
    private http: HttpClient
  ) {
    this.appOrgUrl = environment.appOrgUrl;
   }

  getOpportunityById(id) {
    let url = this.appUrl + + id;
    return this.http.get<any>(url).toPromise();
  }

  deleteOpportunity(id) {
    return this.http.delete<any>(this.appUrl + id)
        .toPromise()
        .then(res => res);
}

getUserGroups(organizationId: number): Observable<any[]> {
  return this.http.get<any>(`${this.appOrgUrl}UserGroup/GetMyUserGroups?groupId=0`, {
    // return this.http.get<any>( `${environment.appOrgUrl}UserGroup?groupId=0`, {
    headers: new HttpHeaders({
      "organizationId": `${organizationId}`
    })
  });
}
  
}
